import API from './API.js';
export default class MastersData extends API {
    constructor() {
        super('masters-data');
    }

}
